<template>
  <!-- #region template -->
  <div v-if="!busy">
    <!-- #region header -->
    <div class="mb-2 d-flex justify-content-between align-items-center">
      <span>Selected</span>
      <b-button variant="primary" v-if="element.blueprint" v-on:click="$refs['form-modal'].toggle()">Add New</b-button>
    </div>
    <!-- #endregion -->
    <!-- #region selected -->
    <div class="user-select-none d-flex justify-content-between">
      <div class="w-100 p-2" style="background: #eceff1">
        <draggable class="list-group h-100" @input="handleInput" v-model="selected" v-bind="dragOptions" group="items" @start="drag = true" @end="drag = false">
          <div @click="element.fixed = !element.fixed" v-for="element in selected" :key="element.value" class="list-group-item text-white bg-primary p-2 d-flex justify-content-between align-items-center mb-2">
            <span>{{ element.text }}</span>
            <b-icon class="ml-2" icon="list" aria-hidden="true"></b-icon>
          </div>
        </draggable>
      </div>
      <!-- #endregion -->
      <!-- #region selection -->
      <div class="w-50 p-2" style="background: #78909c">
        <draggable class="list-group h-100" v-model="selection" v-bind="dragOptions" group="items" @start="drag = true" @end="drag = false">
          <div @click="element.fixed = !element.fixed" v-for="element in selection" :key="element.value" class="list-group-item text-white bg-primary p-2 d-flex justify-content-between align-items-center mb-2">
            <span>{{ element.text }}</span>
            <b-icon class="ml-2" icon="list" aria-hidden="true"></b-icon>
          </div>
        </draggable>
      </div>
    </div>
    <!-- #endregion -->
    <!-- #region form-modal -->
    <b-modal hide-footer ref="form-modal" size="xl" title="Add New">
      <div class="p-5">
        <cForm
          @close="
            $refs['form-modal'].toggle()
            update()
          "
          type="add"
          :blueprint="element.blueprint"
          :init="{}"
          :documents="[]" />
      </div>
    </b-modal>
    <!-- #endregion -->
  </div>
  <!-- #endregion -->
</template>

<script>
// #region script
// #region import
import draggable from 'vuedraggable'
import { mapActions } from 'vuex'
// #endregion

// #region export
export default {
  name: 'eMultiSelect',
  components: {
    cForm: () => import('@/components/cForm'),
    draggable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },
  created() {
    this.update()
  },
  data() {
    return {
      busy: true,
      drag: false,
      selection: [],
      selected: [],
    }
  },
  methods: {
    ...mapActions(['firestore/getDocs']),
    /**
     * Updates the available options.
     */
    update() {
      this.busy = true
      if (this.element.collection) {
        this['firestore/getDocs']({
          path: this.element.collection,
        }).then((documents) => {
          this.selection = documents.map((document) => {
            return {
              value: document._reference.path,
              text: document.name,
            }
          })
          this.selected = this.value.map((value) => {
            return this.selection.find((x) => x.value == value)
          })
          this.selection = this.selection.filter((value) => {
            return this.selected.find((x) => x.value == value.value) ? false : true
          })
          this.busy = false
        })
      } else {
        this.selection = this.element.options
        this.selected = this.value.map((value) => {
          return this.selection.find((x) => x.value == value)
        })
        this.selection = this.selection.filter((value) => {
          return this.selected.find((x) => x.value == value.value) ? false : true
        })
        this.busy = false
      }
    },
    /**
     * Fired when an update to the element is made. Emits the changes to the form.
     */
    handleInput() {
      this.$emit(
        'input',
        this.selected.map((selected) => selected.value)
      )
    },
  },
}
// #endregion
// #endregion
</script>
